import { RESOURCE_LINKS } from "~/components/AppFooter/constants";
import type { IFooterCmsLink } from "~/components/AppFooter/types";
import { buildFooterColumnLinks } from "~/components/AppFooter/utils/buildFooterColumnLinks";
import { ROUTES } from "~/constants/routing";
import {
  PLATFORM_TOUR_LINK,
  SITE_LINKS,
  type SiteLink,
} from "~/constants/socials";

const PRIMARY_NAV_URLS = new Set<string>([
  ROUTES.highlights.createURL(),
  ROUTES.insights.createURL(),
  ROUTES.warIndex.createURL(),
  PLATFORM_TOUR_LINK,
]);

export const buildMobileFooterLinks = (
  cmsLinks: IFooterCmsLink[]
): SiteLink[] => [
  ...buildFooterColumnLinks("company", SITE_LINKS, cmsLinks),
  ...buildFooterColumnLinks("explore", [], cmsLinks),
  ...buildFooterColumnLinks("resources", RESOURCE_LINKS, cmsLinks).filter(
    (link) => !!link.to && !PRIMARY_NAV_URLS.has(link.to)
  ),
];
